import ActivateButton from './component';

export default ActivateButton;
